import Vue from 'vue';
import {
  Loading,
  Field,
  Cell,
  CellGroup,
  Button,
  Icon,
  Toast,
  Grid,
  GridItem,
  Popup,
  Panel,
  RadioGroup,
  Radio,
  Step,
  Steps,
  List,
} from 'vant';

Vue.use(Loading);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Popup);
Vue.use(Panel);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Step);
Vue.use(Steps);
Vue.use(List);
